export function ConstraintBar({ constraint, testId }) {
  if (!constraint) return null;
  return (
    <div className="space-y-3" data-testid={testId}>
      <div className="flex items-center gap-2">
        <span className="text-[10px] uppercase tracking-widest text-[var(--oim-text-dim)] font-heading">Binding Constraint</span>
        <span className="text-[9px] font-heading uppercase px-2 py-0.5 rounded-full border" style={{ borderColor: "var(--oim-border)", color: "var(--oim-text-muted)" }}>
          {constraint.constraint_class}
        </span>
      </div>
      <div className="font-mono-data text-lg font-semibold text-[var(--oim-text)]" data-testid="constraint-binding-current">{constraint.binding_constraint}</div>
      <div className="grid grid-cols-2 gap-3 font-mono-data text-xs">
        <div>
          <span className="text-[9px] text-[var(--oim-text-dim)] block">Headroom</span>
          <span className="text-[var(--oim-text)] font-semibold" data-testid="constraint-headroom-current">{constraint.headroom_pct}%</span>
        </div>
        <div>
          <span className="text-[9px] text-[var(--oim-text-dim)] block">Next Binding</span>
          <span className="text-[var(--oim-text)] font-semibold">{constraint.next_binding || "—"} ({constraint.next_binding_headroom_pct}%)</span>
        </div>
      </div>
      <div>
        <span className="text-[9px] text-[var(--oim-text-dim)] block font-mono-data">Value of relief</span>
        <span className="text-sm font-semibold font-mono-data text-[var(--oim-text)]">₹ {constraint.value_of_relief_per_month?.toLocaleString("en-IN")} /month</span>
      </div>
      <div className="font-heading text-sm text-[var(--oim-text)] pt-1 border-t border-[var(--oim-border)]">{constraint.statement}</div>
    </div>
  );
}
